import { Icon as MuiIcon } from "@mui/material";

interface IProps {
  icon?: string;
  img?: string;
  imgProps?: { [key: string]: any };
  iconProps?: { [key: string]: any };
  sx?: { [key: string]: any };
}

export default function Icon(props: IProps) {
  const { icon, img, imgProps, iconProps, sx } = props;

  return (
    <>
      {icon && <MuiIcon {...iconProps}>{icon}</MuiIcon>}
      {img && <img src={img} alt="" {...imgProps} />}
    </>
  );
}
